import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, ShoppingCart } from "lucide-react";
import { CAD } from "../../lib/format";
import { analytics } from "../../lib/analytics/ga4";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function BuyButton({ product, className = "", label = "Buy now" }) {
  const [loading, setLoading] = useState(false);

  const checkout = async () => {
    setLoading(true);
    try {
      analytics.gumroadClick(product.id);
      const { data } = await axios.post(`${API}/payments/checkout`, {
        lookup_key: product.id,
        origin_url: window.location.origin,
      });
      if (data?.checkout_url) {
        window.location.href = data.checkout_url;
      } else {
        throw new Error("no url");
      }
    } catch (err) {
      setLoading(false);
      toast.error("Could not start checkout. Please try again.");
    }
  };

  return (
    <button
      onClick={checkout}
      disabled={loading}
      data-testid={`buy-btn-${product.id}`}
      className={`inline-flex items-center justify-center gap-2 rounded-full bg-action px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-action-hover disabled:opacity-60 ${className}`}
    >
      {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <ShoppingCart className="h-4 w-4" />}
      {label} — {CAD(product.price)} CAD
    </button>
  );
}
